// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// APPLICATION BUSINESS UNIT SCHEMA
/////////////////////////////////////////

export const ApplicationBusinessUnitSchema = z.object({
  id: z.string(),
  tenantId: z.string().nullable(),
  applicationId: z.string(),
  businessUnitId: z.string(),
  createdAt: z.coerce.date(),
})

export type ApplicationBusinessUnit = z.infer<typeof ApplicationBusinessUnitSchema>

export default ApplicationBusinessUnitSchema;
